
import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SkillIconProps {
  name: string;
  icon: ReactNode;
  isActive?: boolean;
  index?: number;
  isAnimating?: boolean;
}

const SkillIcon = ({ 
  name, 
  icon, 
  isActive = false, 
  index = 0,
  isAnimating = false
}: SkillIconProps) => {
  return (
    <div
      className={cn(
        "group border border-white/50 p-6 flex flex-col items-center justify-center transition-all duration-500 relative",
        isActive
          ? "bg-white text-black"
          : "hover:bg-white hover:text-black",
        "opacity-0 animate-fade-in"
      )}
      style={{ 
        animationDelay: `${index * 100}ms`,
        transformOrigin: "center center"
      }}
    >
      <div className={cn(
        "mb-3 text-2xl transition-all duration-300",
        isActive ? "scale-110" : "group-hover:scale-110",
        isAnimating && "animate-bounce"
      )}>
        {icon}
      </div>
      <span className="text-sm font-medium uppercase tracking-wider">{name}</span>

      {/* Ripple effect when animating */}
      {isAnimating && (
        <div className="absolute inset-0 z-0 overflow-hidden">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-5 h-5 bg-white rounded-full animate-ping"></div>
        </div>
      )}

      {/* Animated corners */}
      <div className={cn(
        "absolute top-0 left-0 w-4 h-4 border-t border-l border-white transition-transform duration-300 origin-top-left",
        isActive || isAnimating ? "scale-100" : "scale-0 group-hover:scale-100"
      )}></div>
      <div className={cn(
        "absolute top-0 right-0 w-4 h-4 border-t border-r border-white transition-transform duration-300 origin-top-right",
        isActive || isAnimating ? "scale-100" : "scale-0 group-hover:scale-100"
      )}></div>
      <div className={cn(
        "absolute bottom-0 left-0 w-4 h-4 border-b border-l border-white transition-transform duration-300 origin-bottom-left",
        isActive || isAnimating ? "scale-100" : "scale-0 group-hover:scale-100"
      )}></div>
      <div className={cn(
        "absolute bottom-0 right-0 w-4 h-4 border-b border-r border-white transition-transform duration-300 origin-bottom-right",
        isActive || isAnimating ? "scale-100" : "scale-0 group-hover:scale-100"
      )}></div>
    </div>
  );
};

export default SkillIcon;
